import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import FoodList from './components/FoodList';

const { Cell } = ResponsiveGrid;

const Food = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="送件服務"
        breadcrumbs={[
          {
            name: '送件服務',
          },
          {
            name: '送件服務頁面',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <FoodList />
    </Cell>
  </ResponsiveGrid>
);

export default Food;
